export const RE_CAPTCHA_SITE_KEY = process.env.RECAPTCHA_SECRET_FRONTEND;

export const TEST_ID_RECAPTCHA = 'TEST_ID_RECAPTCHA';
